import React, { Fragment } from "react";
import Select from "components/Form/fields/Select";
import { useFormikContext, useField } from "formik";
import get from "lodash/get";
import { SelectFieldPropTypes } from "utils/propTypes";

const DEFAULT_CLASSES = {
  container: "w-100 flex flex-column justify-between",
  label: "f6 w-100 fw5 mb2",
  selectWrapper: "f5 w-100",
  select: "border-box input-reset ba b--black-20 pa2 mb0 db w-100 pv2 f5 br2",
  error: "f6 w-100 self-center pt2 tl color-error"
};

const SelectField = ({
  label,
  name,
  disabled,
  options,
  errorLabel,
  customClasses,
  labelTransform
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const [field] = useField(name);
  const { value } = field;

  const {
    touched,
    errors,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const error = get(errors, name);
  const showError = Boolean(get(touched, name) && error);
  const selectProps = {
    options: options,
    stateKey: name,
    value,
    disabled,
    onChange: () => (evt) => {
      const selection = evt.currentTarget.value;
      setFieldValue(name, selection);

      if (!get(touched, name)) {
        setFieldTouched(name, true);
      }
    },
    customClasses: {
      input: classes.select
    },
    labelTransform
  };

  return (
    <Fragment>
      <div className={classes.container}>
        {label && <div className={classes.label}>{label}</div>}
        <div className={classes.selectWrapper}>
          <Select {...selectProps} />
        </div>
      </div>
      {showError && (
        <div className={classes.errorLabel}>
          {errorLabel || `The selected value is invalid`}
        </div>
      )}
    </Fragment>
  );
};

SelectField.propTypes = SelectFieldPropTypes;

export default SelectField;
